import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetControlGroupSplitTest = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, controlGroupEnabled: boolean, controlGroupWeight: number) => {
      dispatch({
        type: 'SET_SPLIT_TEST_CONTROL_GROUP',
        payload: {
          id,
          controlGroupEnabled,
          controlGroupWeight,
        },
      });
    },
    [dispatch],
  );
};
